<div class="main px-5">
  <div class="col-12 mt-3 py-2 px-5 bg-light-color" [class.d-none]="route.children.length !== 0">
    <div class="row row-cols-1 row-cols-sm-2 py-4">
      <div class="col d-flex align-items-center">
        <h1 class="fs-4 fw-bold text-primary-color my-0">Relatório de Histórico de Acesso</h1>
      </div>
    </div>

    <nz-divider class="m-0 p-0 mt-2 mb-4"></nz-divider>
    <div class="col-12">

      <form [formGroup]="historicoAcessoForm" (ngSubmit)="pesquisar()">
        <div class="row row-cols-1 row-cols-sm-3 g-4">


        <div class="col-sm-4 form-group">
          <label for="usuarioId" class="form-label">Usuário</label>
          <nz-select formControlName="usuarioId" nzShowSearch nzAllowClear nzPlaceHolder="Situação" nzSize="large"
            [compareWith]="compareFn">
            <nz-option [nzValue]="item?.id" [nzLabel]="item?.nome" *ngFor="let item of usuarioList" />
          </nz-select>
        </div>
        <div class="col col-sm-2 form-group">
          <label for="dataInicio" class="form-label">Data de</label>
          <nz-date-picker id="dataInicio" [nzFormat]="'dd/MM/YYYY'" [nzSize]="'large'"
            formControlName="dataInicio" (input)="onInputDateChange($event, 'dataInicio')" [nzAllowClear]="true"></nz-date-picker>
        </div>

        <div class="col col-sm-2 form-group">
          <label for="dataFim" class="form-label">Data Até</label>
          <nz-date-picker id="dataFim" [nzFormat]="'dd/MM/YYYY'" [nzSize]="'large'"
            formControlName="dataFim" (input)="onInputDateChange($event, 'dataFim')" [nzAllowClear]="true"></nz-date-picker>
        </div>
        <div *ngIf="historicoAcessoForm.hasError('dataInicioMaiorQueDataFim')" class="alert alert-danger d-flex align-items-center p-3 mt-2" role="alert">
          <i class="bi bi-exclamation-circle-fill me-2" style="font-size: 1.5rem;"></i>
          <span><strong>Erro:</strong> A data de início não pode ser maior que a data de fim.</span>
        </div>



        </div>

        <div class="form-group d-flex justify-content-end ml-3">
          <button nz-button type="submit" nzType="primary" [nzSize]="size" class="rounded-pill mt-4 me-3" [disabled]="!historicoAcessoForm.valid" aria-label="Pesquisar">
            Pesquisar
          </button>
          <button nz-button type="button" nzType="default" [nzSize]="size" class="rounded-pill mt-4 me-3"
            (click)="resetForm()">
            Limpar
          </button>
        </div>
      </form>

    </div>

    <div class="col-12">
      <nz-divider class="m-0 p-0 mt-4 mb-4"></nz-divider>
      <div class="d-flex flex-column page-content border border-radius w-100">
        <nz-table [nzData]="dataSet" [nzSize]="'small'" [nzFrontPagination]="false" [nzShowPagination]="false"
          (nzQueryParams)="sort($event)" [nzFooter]="footerTemplate" [nzNoResult]="semDadosTemplate">
          <thead>
            <tr>
                  <th nzColumnKey="usuario.nome" nzShowSort [nzSortFn]="true">
                    Nome
                  </th>
                  <th nzColumnKey="usuario.email" nzShowSort [nzSortFn]="true">
                    E-mail
                  </th>
                  <th nzColumnKey="usuario.login" nzShowSort [nzSortFn]="true">
                    Login
                  </th>
                  <th nzColumnKey="creationDate" nzShowSort [nzSortFn]="true">
                    Data de Acesso
                  </th>
                  <th nzColumnKey="expirationDateTime" nzShowSort [nzSortFn]="true">
                    Data para Expiração
                  </th>
                  <th nzColumnKey="status" nzShowSort [nzSortFn]="false"[nzSortFn]="true">
                    Status
                  </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="paginator?.paginaAtual">
              <tr *ngFor="let item of dataSet">
                <td>{{ item?.nome }}</td>
                <td>{{ item?.email }}</td>
                <td>{{ item?.login }}</td>
                <td>{{ item?.dataAcesso }}</td>
                <td>{{ item?.dataExpiracao}}</td>
                <td>{{ item?.status }}</td>



              </tr>
            </ng-container>
          </tbody>
        </nz-table>
        <ng-template #footerTemplate>
          <section class="d-flex justify-content-end w-100">
            <app-pagination [itemPorPagina]="10"></app-pagination>
          </section>
        </ng-template>
        <ng-template #semDadosTemplate>
          <div class="d-flex align-items-center justify-content-center" *ngIf="!dataSet?.length">
            <nz-empty [nzNotFoundContent]="'Nenhum registro encontrado'"></nz-empty>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
